export default function ({ store, $axios, $cookies, req }, inject) {
    async function getItem(itemId, options) {
        return await store.dispatch('item/getItem', { itemId, options, $axios, $cookies });
    }

    inject('item', { getItem });
}